import { FormEvent, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { verifyOtpApi } from "../api/api";

export default function OtpPage() {
  const navigate = useNavigate();
  const {
    pendingLogin,
    completeLogin,
    isHydrated,
  } = useAuth();

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isHydrated && !pendingLogin) {
      navigate("/login");
    }
  }, [pendingLogin, isHydrated, navigate]);

  const handleSubmit = async (
    e: FormEvent
  ) => {
    e.preventDefault();
    setError("");

    if (!otp) {
      setError("Please enter the OTP code.");
      return;
    }

    if (!pendingLogin) {
      navigate("/login");
      return;
    }

    try {
      setLoading(true);

      if (!pendingLogin?.email) {
        setError("Session expired. Please login again.");
        navigate("/login");
        return;
      }

      const otpResponse = await verifyOtpApi(
        pendingLogin.email,
        otp
      );

      console.log("OTP Response:", otpResponse);
      console.log("Pending Login:", pendingLogin);

      const updatedPendingLogin = {
        email: otpResponse.user?.email || pendingLogin.email,
        accessToken:
          otpResponse.access_token || pendingLogin.accessToken,
        expiresIn:
          otpResponse.expires_in || pendingLogin.expiresIn,
        user: {
          id: otpResponse.user?.login_id || pendingLogin.user.id,
          name: otpResponse.user?.name || pendingLogin.user.name,
          email: otpResponse.user?.email || pendingLogin.user.email,
          role:
            otpResponse.user?.user_type ||
            pendingLogin.user.role,
          token:
            otpResponse.access_token ||
            pendingLogin.user.token,
          expiresIn:
            otpResponse.expires_in ||
            pendingLogin.user.expiresIn,
        },
      };

      console.log("Updated Pending Login:", updatedPendingLogin);
      completeLogin(updatedPendingLogin);
      console.log("Login completed, navigating to /");
      
      // Small delay to ensure state updates before navigation
      setTimeout(() => {
        navigate("/");
      }, 100);
    } catch (err: any) {
      setError(
        err.message ||
          "OTP verification failed"
      );
    } finally {
      setLoading(false);
    }
  };

  if (!isHydrated || !pendingLogin) {
    return null;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            🔐
          </div>
          <h1>Enter OTP</h1>
          <p>
            Please enter the one-time
            password sent to your email.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">
              OTP Code
            </label>
            <div className="input-wrap">
              <input
                type="text"
                className="form-input"
                placeholder="680266"
                value={otp}
                onChange={(e) =>
                  setOtp(e.target.value)
                }
              />
            </div>
          </div>

          {error && (
            <div className="error-msg">
              ⚠️ {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
          >
            {loading
              ? "Verifying..."
              : "Submit OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}
